import { Outlet, createFileRoute } from '@tanstack/react-router';

// Layout route for the Costume Command Center. The /admin parent route gates on
// the `admin` role server-side, so this subtree inherits that guard — no extra
// check here (matches admin.recital-packages.tsx and every other admin.* route).
export const Route = createFileRoute('/admin/costumes')({
  component: CostumesRoute,
});

function CostumesRoute() {
  return <Outlet />;
}
